import React from "react";
import PropTypes from "prop-types";

import { Header } from "semantic-ui-react";

function SectionHeader({ children, subheader, ...props }) {
  return (
    <Header as="h1" {...props}>
      <Header.Content>
        {children}
        <Header.Subheader style={{ color: "#1B1C1D" }}>
          {subheader}
        </Header.Subheader>
      </Header.Content>
    </Header>
  );
}

SectionHeader.propTypes = {
  subheader: PropTypes.node,
  children: PropTypes.node,
};

SectionHeader.defaultProps = {
  subheader: null,
  children: null,
};

export default SectionHeader;
